import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitLead = async (payload) => {
  const res = await axios.post(`${API}/leads`, payload);
  return res.data;
};

export const verifyAdmin = async (password) => {
  const res = await axios.post(
    `${API}/admin/verify`,
    {},
    { headers: { "X-Admin-Password": password } }
  );
  return res.data;
};

export const fetchLeads = async (password) => {
  const res = await axios.get(`${API}/leads`, {
    headers: { "X-Admin-Password": password },
  });
  return res.data;
};

export const deleteLead = async (id, password) => {
  const res = await axios.delete(`${API}/leads/${id}`, {
    headers: { "X-Admin-Password": password },
  });
  return res.data;
};
